import { useSelector } from 'react-redux';

const useFeatureFlag = (key) => {
  const featureFlags = useSelector((state) => state.user.featureFlags);
  return featureFlags[key] ?? false;
};

export default useFeatureFlag;
